const $ = jQuery.noConflict();

$(document).ready(function () {

  let $btn = $('.optimist-container .btn'), page = 12;
  let $label = $('#optimists #list .icon-item .label li:nth-child(2)');

  $btn.click(function () {

  	$('.optimist-container li.hide[data-filter="true"]').slice(0, page).show();
  	$('.optimist-container li.hide[data-filter="true"]').slice(0, page).removeClass('hide');

  	//if there are no hidden items left
    if ($('.optimist-container li.hide[data-filter="true"]').length === 0){
  	  $('.optimist-container .btn-container').hide();
  	}

  	return false;
  });



  // checkbox filter
  $label.click(function () {

    /*$(this).parent().find('.box').prop('checked', function (i, value) {
      return !value;
    });*/

    $(this).parent().find('.box').trigger('click');
  });



  // filter has been changed
  $('input.box[type="checkbox"]').change(function () {
    let count = 0;

    //reset
    $('.optimist-list > li').attr({'data-filter': 'false'});
    $('.optimist-list > li').removeClass('show');
    $('.optimist-list > li').addClass('hide');
    $('.optimist-list > li').hide();
    $('.optimist-container .btn-container').hide();

    //set filter values
    $('input.box[type="checkbox"]:checked').map(function (index, el) {
      let val = $(el).val();

      $('.optimist-list > li[data-category="' + val + '"]').each(function () {
        if (count < page) {
          $(this).removeClass('hide');
          $(this).addClass('show');
          $(this).show();
        } else {
          $('.optimist-container .btn-container').show();
        }

        $(this).attr({'data-filter': 'true'});
        count++;
      });

      //console.log(index);
    });

    //if there are no check marks show everything
    if ($('input.box[type="checkbox"]:checked'). length === 0) {

      $('.optimist-list > li').each(function () {
        if (count < page) {
          $(this).removeClass('hide');
          $(this).addClass('show');
          $(this).show();
        } else {
          $('.optimist-container .btn-container').show();
        }

        $(this).attr({'data-filter': 'true'});
        count++;
      });
    }
  });
});